import { IconInfoCircle, IconAlertTriangle, IconCircleCheck, IconCircleX, IconInfoSquare } from "@tabler/icons";

import { SnackbarKeys } from "@sso/constant";
import { SnackbarType } from "@sso/types";
import { Flex } from "@sso/ui/FlexBox";

interface SnackbarIconProps {
  type: SnackbarType;
}

export const SnackbarIcon = ({ type }: SnackbarIconProps) => {
  const Icon = () => {
    switch (type) {
      case SnackbarKeys.INFO:
        return <IconInfoCircle />;
      case SnackbarKeys.ERROR:
        return <IconCircleX />;
      case SnackbarKeys.SUCCESS:
        return <IconCircleCheck />;
      case SnackbarKeys.WARNING:
        return <IconAlertTriangle />;
      default:
        return <IconInfoSquare />;
    }
  };
  return (
    <Flex>
      <Icon />
    </Flex>
  );
};
